export const ReviewTags = {
  FilterWorkItemsByTemplate: 'FilterWorkItemsByTemplate',
  HideReviewDateRange: 'HideReviewDateRange',
  HideReviewMeetingDate: 'HideReviewMeetingDate',
};
